export function resolveOrgInitialsForAvatar(name) {
    var _a, _b;
    const parts = name.split(' ');
    let initials = '';
    if (parts.length > 1) {
        initials = parts
            .slice(0, 2)
            .map((part) => part[0])
            .join('')
            .toUpperCase();
    }
    else {
        initials = (_b = (_a = parts[0]) === null || _a === void 0 ? void 0 : _a.slice(0, 2)) === null || _b === void 0 ? void 0 : _b.toUpperCase();
    }
    return initials;
}
